<ngx-spinner bdColor ="rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "square-jelly-box" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>
<div class="px-4 my-2">
    <h1 class="my-5 text-center">Registeration Form</h1>
<form [formGroup]="registerForm" (ngSubmit)="register()">
    <div class="col-md-9 offset-md-2 mt-5">
           
        <div class="form-group">
            <label>First Name</label>
            <input [class.is-invalid]="registerForm.controls.first_name.invalid&&registerForm.controls.first_name.touched" formControlName="first_name" type="text" class=" form-control mt-1 rounded">
            <div *ngIf="registerForm.controls.first_name.invalid&&registerForm.controls.first_name.touched"  class="alert my-2 ml-2 ">
               Your first name is not valid, no space, special chars or numbers allowed
           </div>
        </div>
        </div>
        <div class="col-md-9 offset-md-2 mt-5">
           
            <div class="form-group">
                <label>Last Name</label>
                <input [class.is-invalid]="registerForm.controls.last_name.invalid&&registerForm.controls.last_name.touched" formControlName="last_name" type="text" class="form-control mt-1 rounded">
                <div *ngIf="registerForm.controls.last_name.invalid&&registerForm.controls.last_name.touched"  class="alert my-2 ml-2 ">
                   Your last name is not valid, no space, special chars or numbers allowed
               </div>
            </div>
            </div>
        <div class="col-md-9 offset-md-2 mt-5">
           
            <div class="form-group">
                <label>Email</label>
                <input [class.is-invalid]="registerForm.controls.email.invalid&&registerForm.controls.email.touched" formControlName="email" type="email" class="form-control mt-1 rounded">
                <div *ngIf="registerForm.controls.email.invalid&&registerForm.controls.email.touched"  class="alert my-2 ml-2 ">
                   Your mail is not valid
               </div>
            </div>
            </div>
           
                <div class="col-md-9 offset-md-2 mt-5">
           
                    <div class="form-group">
                        <label>Password</label>
                        <input [class.is-invalid]="registerForm.controls.password.invalid&&registerForm.controls.password.touched" formControlName="password" type="password" class="form-control mt-1 rounded">
                        <div *ngIf="registerForm.controls.password.invalid&&registerForm.controls.password.touched"  class="alert my-2 ml-2 ">
                           Your password is not valid, length must be 8 at least containing char and number
                       </div>
                    </div>
                    </div>
             <div class="col-md-9 offset-md-2 mt-2">
                <button class="btn btn-info" type="submit">Register</button>

             </div>
             <p class="text-center my-3">Have an account? <a class="text-primary text-decoration-none" routerLink="/login">Sign In</a></p>
                 </form>
</div>